import angularModule from 'Careers/angularModule/scripts/careers_module';
import defaultImageUrl from 'vectors/graduationcap.svg';

// Level tokens — mirror the canonical set used by the backend DegreeLevelCatalog PORO.
// Dropdown display order per the YIQsRujT mockup: most common allow-submit levels first.
// NOTE: alteration of this list should be kept in sync with
// `CareerProfile::DegreeAirtableLabels::DEGREE_LEVEL_KEY_TO_LABEL` on the server side,
// which sends the label for the selected level to Airtable.
const LEVEL_ORDER = [
    'bachelors_undergraduate',
    'masters_graduate',
    'diplomas',
    'doctorate',
    'associates',
    'international_credentials',
    'professional_certifications',
    'secondary',
    'other',
];

// Map of specific-degree key → Level of Degree.
// NOTE: alteration of this map should be kept in sync with
// `CareerProfile::DegreeLevelCatalog::DEGREE_KEY_TO_LEVEL` on the server side.
const DEGREE_OPTIONS_MAP = {
    // Secondary
    ged: 'secondary',
    high_school_diploma: 'secondary',

    // Associate's
    associate_of_applied_arts: 'associates',
    associate_of_applied_science: 'associates',
    associate_of_arts: 'associates',
    associate_of_engineering: 'associates',
    associate_of_political_science: 'associates',
    associate_of_science: 'associates',

    // Diplomas
    common_professional_examination: 'diplomas',
    postgraduate_diploma: 'diplomas',
    postgraduate_diploma_2: 'diplomas',
    postgraduate_diploma_3: 'diplomas',
    postgraduate_diploma_4: 'diplomas',
    postgraduate_diploma_in_law: 'diplomas',
    diploma_of_college_studies: 'diplomas',
    higher_national_diploma: 'diplomas',
    graduate_diploma: 'diplomas',
    graduate_diploma_2: 'diplomas',
    graduate_diploma_in_law: 'diplomas',

    // International Credentials
    baccalarium: 'international_credentials',
    bachiller: 'international_credentials',
    bakalavr: 'international_credentials',
    bakalurius: 'international_credentials',
    diplom: 'international_credentials',
    diplom_fh: 'international_credentials',
    diploma_iv: 'international_credentials',
    diplome: 'international_credentials',
    diplomirani: 'international_credentials',
    dyplom: 'international_credentials',
    ingeniero: 'international_credentials',
    ingenieur: 'international_credentials',
    ingenieur_2: 'international_credentials',
    laurea: 'international_credentials',
    laurea_magistrale: 'international_credentials',
    licence: 'international_credentials',
    licenciado: 'international_credentials',
    licencjat: 'international_credentials',
    licentiate: 'international_credentials',
    licientaat: 'international_credentials',
    maestria: 'international_credentials',
    magister: 'international_credentials',
    maitrise: 'international_credentials',
    mestrado: 'international_credentials',
    sarjana: 'international_credentials',
    specialista: 'international_credentials',
    titulo: 'international_credentials',

    // Professional Certifications
    acca_member: 'professional_certifications',
    chartered_accountancy: 'professional_certifications',
    cpa: 'professional_certifications',

    // Bachelor's / Undergraduate
    bachelor_of_accounting: 'bachelors_undergraduate',
    bachelor_of_accountancy: 'bachelors_undergraduate',
    bachelor_of_applied_science: 'bachelors_undergraduate',
    bachelor_of_applied_science_2: 'bachelors_undergraduate',
    bachelor_of_architecture: 'bachelors_undergraduate',
    bachelor_of_arts: 'bachelors_undergraduate',
    bachelor_of_arts_2: 'bachelors_undergraduate',
    bachelor_of_arts_honours: 'bachelors_undergraduate',
    bachelor_of_business_administration: 'bachelors_undergraduate',
    bachelor_of_business_management: 'bachelors_undergraduate',
    bachelor_of_business_studies: 'bachelors_undergraduate',
    bachelor_of_civil_engineering: 'bachelors_undergraduate',
    bachelor_of_commerce: 'bachelors_undergraduate',
    bachelor_of_commerce_honours: 'bachelors_undergraduate',
    bachelor_of_commerce_honours_2: 'bachelors_undergraduate',
    bachelor_of_computer_applications: 'bachelors_undergraduate',
    bachelor_of_computer_science: 'bachelors_undergraduate',
    bachelor_of_computer_science_2: 'bachelors_undergraduate',
    bachelor_of_computer_science_3: 'bachelors_undergraduate',
    bachelor_of_dentistry: 'bachelors_undergraduate',
    bachelor_of_education: 'bachelors_undergraduate',
    bachelor_of_electrical_engineering: 'bachelors_undergraduate',
    bachelor_of_engineering: 'bachelors_undergraduate',
    bachelor_of_engineering_2: 'bachelors_undergraduate',
    bachelor_of_engineering_honours: 'bachelors_undergraduate',
    bachelor_of_engineering_in_electrical_engineering: 'bachelors_undergraduate',
    bachelor_of_fine_arts: 'bachelors_undergraduate',
    bachelor_of_information_technology: 'bachelors_undergraduate',
    bachelor_of_laws: 'bachelors_undergraduate',
    bachelor_of_laws_2: 'bachelors_undergraduate',
    bachelor_of_laws_honours: 'bachelors_undergraduate',
    bachelor_of_library_science: 'bachelors_undergraduate',
    bachelor_of_library_science_2: 'bachelors_undergraduate',
    bachelor_of_literature: 'bachelors_undergraduate',
    bachelor_of_management_studies: 'bachelors_undergraduate',
    bachelor_of_mathematics: 'bachelors_undergraduate',
    bachelor_of_mechanical_engineering: 'bachelors_undergraduate',
    bachelor_of_medical_laboratory_science: 'bachelors_undergraduate',
    bachelor_of_medical_science: 'bachelors_undergraduate',
    bachelor_of_medicine: 'bachelors_undergraduate',
    bachelor_of_medicine_and_surgery: 'bachelors_undergraduate',
    bachelor_of_medicine_and_surgery_2: 'bachelors_undergraduate',
    bachelor_of_medicine_and_surgery_3: 'bachelors_undergraduate',
    bachelor_of_medicine_and_surgery_4: 'bachelors_undergraduate',
    bachelor_of_medicine_and_surgery_5: 'bachelors_undergraduate',
    bachelor_of_medicine_and_surgery_6: 'bachelors_undergraduate',
    bachelor_of_music: 'bachelors_undergraduate',
    bachelor_of_music_2: 'bachelors_undergraduate',
    bachelor_of_nursing: 'bachelors_undergraduate',
    bachelor_of_pharmacy: 'bachelors_undergraduate',
    bachelor_of_pharmacy_2: 'bachelors_undergraduate',
    bachelor_of_philosophy: 'bachelors_undergraduate',
    bachelor_of_physical_therapy_and_physiotherapy: 'bachelors_undergraduate',
    bachelor_of_science: 'bachelors_undergraduate',
    bachelor_of_science_2: 'bachelors_undergraduate',
    bachelor_of_science_honours: 'bachelors_undergraduate',
    bachelor_of_science_in_education: 'bachelors_undergraduate',
    bachelor_of_science_in_electrical_engineering: 'bachelors_undergraduate',
    bachelor_of_science_in_electrical_engineering_2: 'bachelors_undergraduate',
    bachelor_of_science_in_nursing: 'bachelors_undergraduate',
    bachelor_of_technology: 'bachelors_undergraduate',
    bachelor_of_technology_honours: 'bachelors_undergraduate',

    // Master's / Graduate
    master_in_urban_planning: 'masters_graduate',
    master_of_advanced_studies: 'masters_graduate',
    master_of_advanced_studies_2: 'masters_graduate',
    master_of_architecture: 'masters_graduate',
    master_of_arts: 'masters_graduate',
    master_of_arts_2: 'masters_graduate',
    master_of_business_administration: 'masters_graduate',
    executive_master_of_business_administration: 'masters_graduate',
    master_of_chemistry: 'masters_graduate',
    master_of_commerce: 'masters_graduate',
    master_of_commerce_2: 'masters_graduate',
    master_of_commerce_3: 'masters_graduate',
    master_of_computer_applications: 'masters_graduate',
    master_of_divinity: 'masters_graduate',
    master_of_education: 'masters_graduate',
    master_of_education_2: 'masters_graduate',
    master_of_engineering: 'masters_graduate',
    master_of_engineering_2: 'masters_graduate',
    master_of_fine_arts: 'masters_graduate',
    master_of_international_affairs: 'masters_graduate',
    master_of_international_studies: 'masters_graduate',
    master_of_laws: 'masters_graduate',
    master_of_music: 'masters_graduate',
    master_of_music_2: 'masters_graduate',
    master_of_pharmacy: 'masters_graduate',
    master_of_pharmacy_2: 'masters_graduate',
    master_of_philosophy: 'masters_graduate',
    master_of_physical_therapy_and_physiotherapy: 'masters_graduate',
    master_of_physics: 'masters_graduate',
    master_of_physics_honours: 'masters_graduate',
    master_of_public_health: 'masters_graduate',
    master_of_research: 'masters_graduate',
    master_of_science: 'masters_graduate',
    master_of_science_2: 'masters_graduate',
    master_of_science_3: 'masters_graduate',
    master_of_science_4: 'masters_graduate',
    master_of_science_in_education: 'masters_graduate',
    master_of_social_work: 'masters_graduate',
    master_of_studies: 'masters_graduate',
    master_of_technology: 'masters_graduate',
    nurse_practitioner: 'masters_graduate',

    // Doctorate
    doctor_of_dental_surgery: 'doctorate',
    doctor_of_education: 'doctorate',
    doctor_of_medicine: 'doctorate',
    doctor_of_medicine_in_dentistry: 'doctorate',
    doctor_of_naturopathic_medicine: 'doctorate',
    doctor_of_nursing_practice: 'doctorate',
    doctor_of_osteopathic_medicine: 'doctorate',
    doctor_of_pharmacy: 'doctorate',
    doctor_of_pharmacy_2: 'doctorate',
    doctor_of_philosophy: 'doctorate',
    doctor_of_philosophy_2: 'doctorate',
    doctor_of_physical_therapy_and_physiotherapy: 'doctorate',
    doctor_of_veterinary_medicine: 'doctorate',
    juris_doctor: 'doctorate',
};

angularModule.factory('EducationExperience', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');
        const TranslationHelper = $injector.get('TranslationHelper');
        const educationExperienceDetailTranslationHelper = new TranslationHelper(
            'careers.edit_career_profile.education_experience_detail',
        );

        return Iguana.subclass(function () {
            this.alias('EducationExperience');
            this.setIdProperty('id');
            this.embedsMany('transcripts', 'S3TranscriptAsset');

            this.extend({
                levelOrder: LEVEL_ORDER,
                degreeOptions: Object.keys(DEGREE_OPTIONS_MAP),

                levelForDegreeKey(key) {
                    return DEGREE_OPTIONS_MAP[key] || null;
                },
            });
            this.degreeOptionsSet = {};
            this.degreeOptions.forEach(key => {
                this.degreeOptionsSet[key] = true;
            });

            this.setCallback('after', 'copyAttrsOnInitialize', function () {
                this.transcripts = this.transcripts || [];
            });

            Object.defineProperty(this.prototype, 'imageUrl', {
                get() {
                    return this.educational_organization && this.educational_organization.image_url
                        ? this.educational_organization.image_url
                        : defaultImageUrl;
                },
            });

            Object.defineProperty(this.prototype, 'orgName', {
                get() {
                    return this.educational_organization && this.educational_organization.text;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'degreeAndMajorString', {
                get() {
                    return [this.degreeName, this.major].filter(Boolean).join(', ');
                },
            });

            Object.defineProperty(this.prototype, 'degreeAndOrgNameString', {
                get() {
                    // Degree is required in the application form, but I do see some in the db
                    // without it, so being defensive here
                    return this.degreeName ? `${this.degreeName} - ${this.orgName}` : this.orgName;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'degreeName', {
                get() {
                    return this.constructor.degreeOptionsSet[this.degree]
                        ? educationExperienceDetailTranslationHelper.get(this.degree)
                        : this.degree;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'degreeProgram', {
                get() {
                    return this.degree_program;
                },
                set(val) {
                    this.degree_program = val;
                },
            });

            Object.defineProperty(this.prototype, 'willNotComplete', {
                get() {
                    return this.will_not_complete;
                },
                set(val) {
                    this.will_not_complete = val;
                },
            });

            // this determines if the education experience is empty in the context of the education form.
            // if any of the form fields change, we should verify that this property still works as expected
            Object.defineProperty(this.prototype, 'isEmpty', {
                get() {
                    return (
                        (!this.educational_organization || !this.educational_organization.text) &&
                        !this.degree &&
                        !this.major &&
                        !this.minor &&
                        !this.gpa &&
                        angular.isUndefined(this.willNotComplete)
                    );
                },
            });

            Object.defineProperty(this.prototype, 'transcriptUploaded', {
                get() {
                    return this.transcripts.length > 0;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'officialTranscriptUploaded', {
                get() {
                    return this.transcripts.filter(transcript => transcript.transcript_type === 'official').length > 0;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'unofficialTranscripts', {
                get() {
                    return this.transcripts.filter(transcript => transcript.transcript_type === 'unofficial');
                },
                configurable: true,
            });

            // See also transcript_requirement_helper.rb
            Object.defineProperty(this.prototype, 'canRequireOfficial', {
                get() {
                    return (
                        this.degreeProgram &&
                        !this.will_not_complete &&
                        this.graduation_year <= new Date().getFullYear()
                    );
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'officialTranscriptUploadedOrWaived', {
                get() {
                    return this.officialTranscriptUploaded || this.transcriptWaived;
                },
                configurable: true,
            });

            // See also education_experience.rb
            Object.defineProperty(this.prototype, 'transcriptApprovedOrWaived', {
                get() {
                    return this.transcript_approved || this.transcriptWaived;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'officialTranscriptInReview', {
                get() {
                    return this.official_transcripts_in_review;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'transcriptWaived', {
                get() {
                    return !!this.transcript_waiver;
                },
                configurable: true,
            });

            return {};
        });
    },
]);
